'use client';
import type { CSSProperties, ReactElement } from 'react';
import { motion } from 'framer-motion';
import { Cbullshitcoding } from '@/components/ui/Cbullshitcoding';
import { Cimage } from '@/components/ui/Cimage';
import { WritingChunks } from '@/types/frontend-types';
import type { Temper } from '@/types/frontend-types';
import { ContactFormStep, getContactCodeFile, getVisibleOpacity, } from './footerModels';
interface CfooterTriangleDecorationProps {
    isVisible: boolean;
    frameStyle: CSSProperties;
}
interface CfooterGlowProps {
    isVisible: boolean;
    glowStyle: CSSProperties;
}
interface CfooterCodeMaskProps {
    isVisible: boolean;
    isSubmitting: boolean;
    contactStep: ContactFormStep;
    codingTemper: Temper;
    codingClearOnEnd: boolean;
    codeReplacements: Record<string, string>;
    codingStyle: CSSProperties;
    codingFadeWrapperStyle: CSSProperties;
    codeMaskStyle: CSSProperties;
}
export function CfooterTriangleDecoration({ isVisible, frameStyle, }: CfooterTriangleDecorationProps): ReactElement {
    return (
      <motion.div initial={{ opacity: 0 }} animate={{ opacity: getVisibleOpacity({ isVisible, visibleOpacity: 1 }) }} transition={{ duration: 2, ease: [0.4, 0, 0.2, 1] }} style={frameStyle}>
        <Cimage src="/triangles/outlined-accent.svg" alt="" width="100%" height="100%" static={true} animation="none" objectFit="contain" ariaHidden={true} style={{
            width: '100%',
            height: '100%',
            display: 'block',
        }}/>
      </motion.div>
    );
}
export function CfooterGlow({ isVisible, glowStyle, }: CfooterGlowProps): ReactElement {
    return (
      <motion.div initial={{ opacity: 0 }} animate={{ opacity: getVisibleOpacity({ isVisible, visibleOpacity: 0.11 }) }} transition={{
            duration: 2,
            delay: getVisibleOpacity({ isVisible, visibleOpacity: 2 }),
            ease: [0.4, 0, 0.2, 1],
        }} style={glowStyle}/>
    );
}
export function CfooterCodeMask({ isVisible, isSubmitting, contactStep, codingTemper, codingClearOnEnd, codeReplacements, codingStyle, codingFadeWrapperStyle, codeMaskStyle, }: CfooterCodeMaskProps): ReactElement {
    return (
      <motion.div initial={{ opacity: 0 }} animate={{ opacity: getVisibleOpacity({ isVisible, visibleOpacity: 1 }) }} transition={{ duration: 2, ease: [0.4, 0, 0.2, 1] }} style={codeMaskStyle}>
        {isVisible && (<Cbullshitcoding codeFile={getContactCodeFile({ contactStep, isSubmitting })} temper={codingTemper} writingChunks={WritingChunks.Letter} speed={1.2} loop={false} clearOnEnd={codingClearOnEnd} replacements={codeReplacements} style={codingStyle} fadeWrapperStyle={codingFadeWrapperStyle}/>)}
      </motion.div>
    );
}
